// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"3759":"echarts","4395":"zrender"}[chunkId] || chunkId) + ".js";
};